import * as React from 'react';
import { NavLink } from "react-router-dom"; // 1. Importa NavLink invece di useNavigate

// Componenti Material-UI
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';

// Icone Material-UI
import DashboardIcon from '@mui/icons-material/Dashboard';
import ApartmentIcon from '@mui/icons-material/Apartment';
import PeopleIcon from '@mui/icons-material/People';
import AssessmentIcon from '@mui/icons-material/Assessment';

const MainListItems = (props) => {
    // Determina i ruoli in modo sicuro
    const isAdmin = !props.user?.roles?.includes("ROLE_CLUB") || false;
    // CORRETTO: Controlla l'array 'roles'
    const isClub = props.user?.roles?.includes("ROLE_CLUB") || false;

    // 2. Rimuoviamo lo stato selectedIndex e la funzione handleListItemClick, non servono più!

    // Stile per il link attivo, applicato automaticamente da NavLink
    const activeLinkStyle = {
        backgroundColor: 'rgba(0, 0, 0, 0.08)'
    };

    return (
        <List component="nav">
            {/* 3. Usiamo NavLink. La prop 'to' gestisce la navigazione. */}
            {/* Lo stile viene applicato in base all'URL corrente. */}
            <ListItemButton
                component={NavLink}
                to="/dashboard"
                end // 'end' assicura che questo link sia attivo solo per il percorso esatto "/"
                style={({ isActive }) => isActive ? activeLinkStyle : undefined}
            >
                <ListItemIcon><DashboardIcon /></ListItemIcon>
                <ListItemText primary="Home" />
            </ListItemButton>

            {/* Mostra queste voci solo se l'utente NON è di tipo "club" */}
            {!isClub && (
                <>
                    <ListItemButton
                        component={NavLink}
                        to="/dashboard/stakeholders"
                        style={({ isActive }) => isActive ? activeLinkStyle : undefined}
                    >
                        <ListItemIcon><PeopleIcon /></ListItemIcon>
                        <ListItemText primary="Contatti" />
                    </ListItemButton>

                    <ListItemButton
                        component={NavLink}
                        to="/dashboard/aziende"
                        style={({ isActive }) => isActive ? activeLinkStyle : undefined}
                    >
                        <ListItemIcon><ApartmentIcon /></ListItemIcon>
                        <ListItemText primary="Aziende" />
                    </ListItemButton>

                    {/* Mostra la voce Report solo se l'utente è Admin */}
                    {isAdmin && (
                        <ListItemButton
                            component={NavLink}
                            to="/dashboard/report"
                            style={({ isActive }) => isActive ? activeLinkStyle : undefined}
                        >
                            <ListItemIcon><AssessmentIcon /></ListItemIcon>
                            <ListItemText primary="Report" />
                        </ListItemButton>
                    )}
                </>
            )}
        </List>
    );
};

export default MainListItems;